import isObject from './isObject';

export const nilKeys = ['null', 'undefined', ''];

export const isProfileSlug = (slug = '') => {
  return slug.startsWith('@');
};

export const isInitiativeSlug = (slug = '') => {
  return slug.startsWith('+');
};

export const isSystemSlug = (slug = '') => {
  return isProfileSlug(slug) || isInitiativeSlug(slug);
};

export const getMapRegExp = (pathMap: Record<string, string | number>) => {
  try {
    if (isObject(pathMap)) {
      const pathMaps = Object.keys(pathMap).filter(
        k => !nilKeys.includes(k) && k,
      );

      const matchRegExpStr = `(${pathMaps.join('|')})(?!-)`;

      return pathMaps.length ? new RegExp(matchRegExpStr, 'g') : '';
    }
  } catch (error) {
    console.error('RegExp error: ', error);
    return '';
  }

  return '';
};
